import React, {PureComponent} from "react"

import {Label2} from "@irati/ui/src/Labels"
import {H2, H3} from "@irati/ui/src/Typography"
import {injectIntl, InjectIntl, FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import Pill from "@irati/ui/src/Pill"
import mainTheme from "@irati/ui/src/global/theme"

import {LabelContainer, ActivityBlockItem, ValueContainer, PillWrapper} from "../styled/styled"

interface Props extends InjectIntl {
  dataItem: number,
  label: string,
  isPercentage?: boolean,
  currency?: string,
  bold?: boolean,
  addLeftPadding?: boolean,
  isCents?: boolean,
  large?: boolean,
  showUKOnlyPill?: boolean
}

class DataItem extends PureComponent<Props> {
  static defaultProps = {
    isPercentage: false,
    label: null,
    isCents: true,
    large: false
  }

  render() {
    const {dataItem, isPercentage, currency, label, bold, addLeftPadding, isCents, large, showUKOnlyPill, formatMessage} = this.props
    const HeaderComp = large ? H2 : H3

    return (
      <ActivityBlockItem addLeftPadding={addLeftPadding}>
        <LabelContainer>
          <Label2 uppercase bold>
            <FormattedMessage id={label} />
          </Label2>
          {showUKOnlyPill && <PillWrapper>
            <Pill
              text={formatMessage({id: "admin.reporting.ukOnly"})}
              isWhiteText
              backgroundColor={mainTheme.colors.secondary2} />
          </PillWrapper>}
        </LabelContainer>
        <ValueContainer>
          {currency ? (
            <HeaderComp bold={bold}>
              <FormattedCurrency currency={currency} value={dataItem} isCents={isCents} />
            </HeaderComp>
          ) : (
            <HeaderComp uppercase bold={bold}>
              {isPercentage ? Math.round(dataItem) : dataItem}
              {isPercentage && "%"}
            </HeaderComp>
          )}
        </ValueContainer>
      </ActivityBlockItem>
    )
  }
}

export default injectIntl(DataItem)
